@if (notificationsStore.loading()) {
  <div class="loader"></div>
}

<cw-tab [selected]="selectedTabId()" [items]="tabs()" (tabChange)="onTabChange($event)">
  @for (tab of tabs(); track tab.slot) {
    <div class="tab-wrapper" [slot]="tab.slot">
      <ng-container *ngTemplateOutlet="items" />
    </div>
  }
</cw-tab>

<ng-template #items>
  <div class="list">
    @if (filtered()?.length) {
      <!-- Filtered -->
      @for (notification of filtered(); track notification.id) {
        <gplus-alarm-card
          [notification]="notification"
          (click)="$event.stopPropagation(); highlight(notification.therapyJobId)"
          (hide)="toggleHide(notification)"
        >
          @if (notification.patient?.careUnit?.room) {
            <cw-badge-status priority="medium" [badge] [status]="notification.level">
              {{ notification.patient?.careUnit?.room }} -
              {{ notification.patient?.careUnit?.bed }}
            </cw-badge-status>
          }
        </gplus-alarm-card>
      }
    } @else {
      {{ 'AlarmCenterNoAlarms' | translate }}
    }
  </div>
</ng-template>
